<span class="html-style font-sans text-xs">
    {{displayValue()}}
    </span>